module.exports = __webpack_public_path__ + "img/formula.a3c9a737.png";